import React from 'react';
import { ITableColumns, ITableDataSource } from 'models/table';
import { Checkbox } from '@mui/material';
import {
  ILicenceFirearmsSearchResponseContent,
  ILicenceFirearmsResponse,
} from 'models/licencesFirearms';
import { IDictionary } from 'models/dictionary';
import { findInDictionary } from 'helpers/dictionary';

export const toSearchResponseFormat = (
  weapon: ILicenceFirearmsResponse,
): ILicenceFirearmsSearchResponseContent => {
  const { licenceUniqueId, firearmUniqueId, ...searchResponseFields } = weapon;
  return {
    ...searchResponseFields,
    keeper: weapon.keeper,
    owner: weapon.owner,
  };
};

interface IFirearmsTableColumns {
  handleCheck: (arg: string, item: any) => void;
  checkedIds: string[];
}

export const firearmsTableColumns = ({
  handleCheck,
  checkedIds,
}: IFirearmsTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f518',
    key: '',
    title: 'general.actions.button',
    isSortable: false,
    align: 'center',
    width: '80px',
    isCenterTableHead: true,
    render: (_data, props) => (
      <Checkbox
        id={`legalEntity_licence_selectFirearm-checkbox-${props.id}`}
        style={{ padding: 0 }}
        checked={checkedIds.includes(props.id)}
        onChange={() => handleCheck(props.id, props)}
      />
    ),
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f610',
    key: 'fireCycleId',
    title: 'registeredFirearms.accordion.fireCycleId.label',
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f515',
    key: 'serialNumber',
    title: 'registeredFirearms.accordion.serialNumber.column',
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f511',
    key: 'type',
    title: 'registeredFirearms.accordion.type.label',
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f571',
    key: 'make',
    title: 'registeredFirearms.accordion.make.column',
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f512',
    key: 'model',
    title: 'registeredFirearms.accordion.model.column',
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f514',
    key: 'calibre',
    title: 'registeredFirearms.accordion.calibre.column',
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f519',
    key: 'action',
    title: 'legalEntity.licenceDetails.weapon.action.column',
  },
];

export const mapFirearmsToDataSource = (
  firearms: ILicenceFirearmsSearchResponseContent[],
  firearmType: IDictionary[] | null,
  make: IDictionary[] | null,
  model: IDictionary[] | null,
  caliber: IDictionary[] | null,
  firearmAction: IDictionary[] | null,
): ITableDataSource[] =>
  firearms.map((firearm) => ({
    id: firearm.uniqueId,
    uniqueId: firearm.uniqueId,
    stateUniqueId: firearm.stateUniqueId,
    legalityUniqueId: firearm.legalityUniqueId,
    activityUniqueId: firearm.activityUniqueId,
    serialNumber: firearm.serialNumber,
    type: findInDictionary(firearm.typeUniqueId, firearmType),
    fireCycleId: firearm.fireCycleId,
    make: findInDictionary(firearm.makeUniqueId, make),
    model: findInDictionary(firearm.modelUniqueId, model),
    calibre: findInDictionary(firearm.calibreUniqueId, caliber),
    action: findInDictionary(firearm.actionUniqueId, firearmAction),
    keeper: firearm.keeper,
    owner: firearm.owner,
  }));
